import { render, staticRenderFns } from "./EducationalCategoryTabs.vue?vue&type=template&id=79579aa4&"
import script from "./EducationalCategoryTabs.vue?vue&type=script&lang=js&"
export * from "./EducationalCategoryTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports